
import { defineComponent, onMounted, ref, watch } from 'vue';
import debounce from 'lodash/debounce';

export default defineComponent({
  name: 'FilterItem',
  props: {
    value: String,
    filter: Object,
    dropdownOptions: Object,
  },
  emits: ['input'],
  setup(props, { emit }) {
    const localInput = ref<string>();

    const onInput = (e: { target: HTMLInputElement }) => {
      const value = e.target.value;

      emit('input', value, props.filter?.name);
    };

    const onInputText = debounce((e: { target: HTMLInputElement }) => {
      const value = e.target.value;
      emit('input', value, props.filter?.name);
    }, 500);

    // re-assign localInput value if props.value updated
    // TODO: extract this logic to share with other components
    watch(
      () => props.value,
      (value, preValue) => {
        if (value !== preValue && localInput.value !== props.value) {
          localInput.value = props.value;
        }
      }
    );

    onMounted(() => {
      localInput.value = props.value;
    });

    return {
      localInput,
      onInput,
      onInputText,
    };
  },
});
